import { useEffect, useRef, useState } from "react";
import { Button, Collapse, Form, InputGroup, Table } from "react-bootstrap";
import { itemServices } from "../../APIServices/PasswordManagement/itemServices";
import { FaSquarePlus, FaXmark } from "react-icons/fa6";
import Swal from "sweetalert2";
import { RiSaveLine } from "react-icons/ri";
import { LuCalendarClock, LuFileChartColumnIncreasing, LuUser } from "react-icons/lu";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { IoArrowForwardOutline } from "react-icons/io5";
import { MdAccessTime, MdLocalPhone, MdOutlineMailOutline, MdOutlineTextFields } from "react-icons/md";
import { IoMdLink } from "react-icons/io";
import { BsCalendar2Date, BsCalendar2Month, BsTextareaResize } from "react-icons/bs";
import { GoNumber } from "react-icons/go";
import { PiPasswordBold } from "react-icons/pi";
import { superAdminMetaServices } from "../../APIServices/MetaManagement/superAdminMetaServices";
import { decryptGroupKey, decryptItemKey, encryptPayload, fetchIFSCDetails, getWebsiteMeta } from "../../APIHelpers/utils";
import { useApp } from "../../APIHelpers/AppContext";
import { GrOrganization } from "react-icons/gr";

const UpdateItem = ({
  getItemList,
  status,
  itemData,
  getUniqueItemList,
  getSingleItem,
  setIsEdit,
  activeItem,
  isDark,
  auth,
  itemCount,
  openCloseMenu,
}) => {
  const { getVaultKey } = useApp();

  let categoryId = itemData?.categoryId
  const [loader, setLoader] = useState(false);
  const [openList, setOpenList] = useState("");
  const [itemInfo, setItemInfo] = useState([]);
  const [cardList, setCardList] = useState([]);
  const [databaseList, setDatabaseList] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [bankList, setBankList] = useState([]);
  const [storageList, setStorageList] = useState([]);
  const [showPasswordMap, setShowPasswordMap] = useState({});
  const [bankDetails, setBankDetails] = useState("");

  const toggleShowPassword = (id) => {
    setShowPasswordMap((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const updatedItem = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Update this Item?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {}
        setLoader(true)
        let metadata = {}
        userData.itemId = itemData?.itemId
        userData.categoryId = categoryId
        if (categoryId === "credentials") {
          let url = itemInfo?.find(item => item.name === "WEBSITE")?.value
          let { title, favicon } = await getWebsiteMeta(url)
          metadata.title = title
          metadata.icon = favicon
        }
        if (categoryId === "bankaccount") {
          let bankType = itemInfo?.find(item => item.name === "BANK")?.value
          let bankData = bankList?.find(item => item.key === bankType)
          metadata.title = bankData?.name
          metadata.icon = bankData?.icon
        }
        if (categoryId === "creditcards" || categoryId === "debitcards") {
          let bankType = itemInfo?.find(item => item.name === "BANK")?.value
          let cardType = itemInfo?.find(item => item.name === "CARD_TYPE")?.value
          let bankData = bankList?.find(item => item.key === bankType)
          let cardData = cardList?.find(item => item.key === cardType)
          metadata.title = `${cardData?.name} (${bankData?.name})`
          metadata.icon = cardData?.icon
        }
        if (categoryId === "securenote" || categoryId === "other") {
          let title = itemInfo?.find(item => item.name === "TITLE")?.value
          metadata.title = title
          metadata.icon = ""
        }
        if (categoryId === "softwarelicense") {
          let title = itemInfo?.find(item => item.name === "SOFTWARE_NAME")?.value
          metadata.title = title
          metadata.icon = ""
        }
        if (categoryId === "file") {
          let title = itemInfo?.find(item => item.name === "FILE_NAME")?.value
          let fileType = itemInfo?.find(item => item.name === "FILE_TYPE")?.value
          let fileData = fileList?.find(item => item.key === fileType)
          metadata.title = title
          metadata.icon = fileData?.icon
        }
        userData.metadata = metadata
        if (itemData?.groupId === "personal") {
          let decryptedItemKey = await decryptItemKey(itemData?.itemKey, itemData?.itemKeyIV, getVaultKey())
          let { encryptedData, encryptedDataIV } = await encryptPayload(itemInfo, decryptedItemKey)
          userData.encryptedData = encryptedData
          userData.encryptedDataIV = encryptedDataIV
        } else {
          let decryptedGroupKey = await decryptGroupKey(itemData?.groupKey, itemData?.groupKeyIV, getVaultKey())
          let decryptedItemKey = await decryptItemKey(itemData?.itemKey, itemData?.itemKeyIV, decryptedGroupKey)
          let { encryptedData, encryptedDataIV } = await encryptPayload(itemInfo, decryptedItemKey)
          userData.encryptedData = encryptedData
          userData.encryptedDataIV = encryptedDataIV
        }
        let data = await itemServices.updatedItem(auth, userData)
        if (data?.statusCode === 200) {
          getItemList()
          getSingleItem(itemData?.itemId)
          getUniqueItemList()
          setIsEdit(false)
        }
        setLoader(false)
      }
    });
  };

  const AppRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (AppRef.current && !AppRef.current.contains(event.target)) {
        setOpenList(false);
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  const addField = (field) => {
    setItemInfo(prev => [
      ...prev,
      {
        id: Math.random().toString().substr(2, 10),
        label: "",
        name: "",
        placeholder: field?.type === "file" ? "Upload File" : field?.type === "time" ? "Select Time" : field?.type === "month" ? "Select Month" : field?.type === "datetime-local" ? "Select Date Time" : field?.type === "textarea" ? "Write here..." : "Enter Value",
        value: "",
        type: field?.type,
        define: "post",
        require: true,
        isEncrypted: true,
      }
    ]);
  };

  const handleChange = (id, key, value) => {
    setItemInfo(prev =>
      prev.map(f => f.id === id ? { ...f, [key]: value } : f)
    );
  };

  const removeField = (id) => {
    setItemInfo(prev => prev.filter(f => f.id !== id));
  };

  const toFieldName = (value = "") => {
    return String(value)
      .trim()
      .toUpperCase()
      .replace(/[^A-Z0-9 ]/g, " ")
      .replace(/\s+/g, "_")
      .replace(/_+/g, "_")
      .replace(/^_+|_+$/g, "");
  };

  const getCardMetaList = async () => {
    const res = await superAdminMetaServices.getMetadataList(auth, "creditdebit");
    setCardList(res?.data || []);
  };

  const getDatabaseMetaList = async () => {
    const res = await superAdminMetaServices.getMetadataList(auth, "database");
    setDatabaseList(res?.data || []);
  };

  const getBankMetaList = async () => {
    const res = await superAdminMetaServices.getMetadataList(auth, "bankaccount");
    setBankList(res?.data || []);
  };

  const getFileMetaList = async () => {
    const res = await superAdminMetaServices.getMetadataList(auth, "file");
    setFileList(res?.data || []);
  };

  const getStorageMetaList = async () => {
    const res = await superAdminMetaServices.getMetadataList(auth, "storage");
    setStorageList(res?.data || []);
  };

  const getIFSCDetails = async (ifscCode) => {
    const res = await fetchIFSCDetails(ifscCode);
    setBankDetails(res);
  };

  const fieldTypes = [
    { type: "text", label: "Text", icon: <MdOutlineTextFields /> },
    { type: "url", label: "URL", icon: <IoMdLink /> },
    { type: "email", label: "Email", icon: <MdOutlineMailOutline /> },
    { type: "textarea", label: "Textarea", icon: <BsTextareaResize /> },
    { type: "date", label: "Date", icon: <BsCalendar2Date /> },
    { type: "month", label: "Month/Year", icon: <BsCalendar2Month /> },
    { type: "time", label: "Time", icon: <MdAccessTime /> },
    { type: "datetime-local", label: "Date-Time", icon: <LuCalendarClock /> },
    { type: "phone", label: "Phone", icon: <MdLocalPhone /> },
    { type: "number", label: "Number", icon: <GoNumber /> },
    { type: "file", label: "File", icon: <LuFileChartColumnIncreasing /> },
    { type: "password", label: "Password", icon: <PiPasswordBold /> },
  ];

  useEffect(() => {
    if (categoryId === "database") {
      getDatabaseMetaList();
    }
    if (categoryId === "file") {
      getFileMetaList();
    }
    if (categoryId === "bankaccount") {
      getBankMetaList();
    }
    if (categoryId === "storage") {
      getStorageMetaList();
    }
    if (categoryId === "creditcards" || categoryId === "debitcards") {
      getCardMetaList();
      getBankMetaList();
    }
  }, [auth, categoryId]);

  useEffect(() => {
    setBankDetails("")
  }, [itemInfo])

  useEffect(() => {
    setItemInfo([...(itemData?.itemInfo || []), ...(itemData?.additionalInfo || [])])
  }, [itemData])

  function isAllRequiredFilled(fields = []) {
    return fields.every(item => {
      if (!item.require) return true;
      return item.value !== undefined &&
        item.value !== null &&
        String(item.value).trim() !== "";
    });
  }

  return (
    <>
      <div className="p-2 hstack justify-content-between gap-2">
        <Button variant={isDark ? "outline-dark" : "outline-light"} className={`${!isDark ? "text-dark" : "text-white"} py-1 px-2 rounded-1 hstack gap-2`}>{itemData?.adminRole === "organization" ? <GrOrganization title={itemData?.adminName} /> : <LuUser title={itemData?.adminName} />} <span style={{ fontSize: 14 }} title={itemData?.adminName}>{itemData?.adminName}</span> {(activeItem === "all" || activeItem === "bookmark" || activeItem === "archived" || activeItem === "trash") && <><IoArrowForwardOutline title={itemData?.groupName} /> <span style={{ fontSize: 14 }} title={itemData?.groupName}>{itemData?.groupName}</span></>}</Button>
        <div className="hstack gap-2">
          {!(status === "archived" || status === "deleted") &&
            <>
              <Button
                variant="outline-primary"
                disabled={!isAllRequiredFilled(itemInfo) || loader}
                onClick={updatedItem}
                className={`py-1 px-2 rounded-1 hstack gap-2`}
                style={{ fontSize: 14 }} title="Update Item">
                <RiSaveLine />Update Item
              </Button>
              <Button variant="outline-danger" className={`py-1 px-2 rounded-1 hstack gap-2`} style={{ fontSize: 14 }} title="Cancel" onClick={() => setIsEdit(false)}><FaXmark /> Cancel</Button>
            </>
          }
        </div>
      </div>
      <div className="p-2 overflow-auto" style={{ height: "calc(100vh - 103px)" }}>
        <div className={`${openCloseMenu && itemCount === 1 ? "w-40" : openCloseMenu || itemCount === 1 ? "w-50" : "w-75"} m-auto`}>
          <Form.Group className="fw-bold mb-3 hstack gap-2" style={{ fontSize: 15 }}>
            <img
              src={itemData?.categoryIcon}
              alt={itemData?.categoryName}
              style={{
                width: 30,
                height: 30,
                objectFit: "contain",
              }}
            />
            <span>{itemData?.categoryName}</span>
          </Form.Group>
          {itemInfo?.map(field => (
            <Form.Group key={field.id} className="mb-2">
              {field?.define === "pre" &&
                <>
                  <Form.Group className="mb-3">
                    <Form.Group className="hstack justify-content-between">
                      <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
                        {field.label}{" "}
                        {field?.require &&
                          <abbr className="text-danger" title="Require">
                            *
                          </abbr>
                        }
                      </Form.Label>
                      {field.name === "IFSC_CODE" && field.value?.length === 11 &&
                        <Button
                          onClick={() => bankDetails ? setBankDetails("") : getIFSCDetails(field.value)}
                          variant="outline-primary"
                          style={{ fontSize: 10 }}
                          className="rounded-1 p-1 mb-1"
                        >
                          View Details
                        </Button>
                      }
                    </Form.Group>
                    {field.type === "textarea" ?
                      <Form.Control
                        as="textarea"
                        rows={3}
                        className="interactive-input"
                        placeholder={field?.placeholder}
                        style={{ fontSize: 12, padding: "26px 15px 10px" }}
                      />
                      : field.type === "select" ?
                        <Form.Select
                          className="interactive-input"
                          style={{ fontSize: 12, padding: "6px 15px" }}
                          onChange={(e) => handleChange(field.id, "value", e.target.value)}
                          value={field.value}
                        >
                          <option value="">{field?.placeholder}</option>
                          {(field?.optionId === "bankaccount" ? bankList
                            : field?.optionId === "creditdebit" ? cardList
                              : field?.optionId === "database" ? databaseList
                                : field?.optionId === "file" ? fileList
                                  : field?.optionId === "storage" ? storageList
                                    : field?.optionId === "custom" ? field?.options
                                      : []
                          )?.map((option, index) => (
                            <option key={index} value={option?.key}>{option?.name}</option>
                          ))}
                        </Form.Select>
                        : field.type === "password" ?
                          <InputGroup key={field.id} className="mb-2">
                            <Form.Control
                              type={showPasswordMap[field.id] ? "text" : "password"}
                              className="interactive-input"
                              style={{ fontSize: 12, padding: "6px 15px" }}
                              placeholder={field?.placeholder}
                              value={field.value}
                              onChange={(e) => handleChange(field.id, "value", e.target.value)}
                            />
                            <InputGroup.Text
                              style={{ cursor: "pointer" }}
                              onClick={() => toggleShowPassword(field.id)}
                            >
                              {showPasswordMap[field.id] ? <FaEyeSlash /> : <FaEye />}
                            </InputGroup.Text>
                          </InputGroup>
                          :
                          <Form.Control
                            type={field.type}
                            className="interactive-input"
                            style={{ fontSize: 12, padding: "6px 15px" }}
                            placeholder={field?.placeholder}
                            value={field.value}
                            onChange={(e) => handleChange(field.id, "value", e.target.value)}
                          />
                    }
                  </Form.Group>
                </>
              }
              <Collapse in={!!bankDetails && field?.name === "IFSC_CODE" && field?.value?.length === 11}>
                <div className="border rounded pt-2 mb-2" style={{ fontSize: 12 }}>
                  <Table hover className="m-0">
                    <thead className="position-sticky top-0">
                      <tr>
                        <th>Attribute</th>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      {bankDetails?.BANK &&
                        <tr>
                          <td className="item-secondary">BANK</td>
                          <td className="item-secondary">{bankDetails?.BANK}</td>
                        </tr>
                      }
                      {bankDetails?.IFSC &&
                        <tr>
                          <td className="item-secondary">IFSC</td>
                          <td className="item-secondary">{bankDetails?.IFSC}</td>
                        </tr>
                      }
                      {bankDetails?.BRANCH &&
                        <tr>
                          <td className="item-secondary">BRANCH</td>
                          <td className="item-secondary">{bankDetails?.BRANCH}</td>
                        </tr>
                      }
                      {bankDetails?.ADDRESS &&
                        <tr>
                          <td className="item-secondary">ADDRESS</td>
                          <td className="item-secondary">{bankDetails?.ADDRESS}</td>
                        </tr>
                      }
                      {bankDetails?.CONTACT &&
                        <tr>
                          <td className="item-secondary">CONTACT</td>
                          <td className="item-secondary">{bankDetails?.CONTACT}</td>
                        </tr>
                      }
                      {bankDetails?.CITY &&
                        <tr>
                          <td className="item-secondary">CITY</td>
                          <td className="item-secondary">{bankDetails?.CITY}</td>
                        </tr>
                      }
                      {bankDetails?.DISTRICT &&
                        <tr>
                          <td className="item-secondary">DISTRICT</td>
                          <td className="item-secondary">{bankDetails?.DISTRICT}</td>
                        </tr>
                      }
                      {bankDetails?.STATE &&
                        <tr>
                          <td className="item-secondary">STATE</td>
                          <td className="item-secondary">{bankDetails?.STATE}</td>
                        </tr>
                      }
                      {bankDetails?.RTGS &&
                        <tr>
                          <td className="item-secondary">RTGS</td>
                          <td className="item-secondary">{bankDetails?.RTGS ? "Yes" : "No"}</td>
                        </tr>
                      }
                      {bankDetails?.BANKCODE &&
                        <tr>
                          <td className="item-secondary">BANKCODE</td>
                          <td className="item-secondary">{bankDetails?.BANKCODE}</td>
                        </tr>
                      }
                    </tbody>
                  </Table>
                </div>
              </Collapse>
            </Form.Group>
          ))}
          {categoryId &&
            <>
              <Form.Group className="mb-2" ref={AppRef}>
                <div className="hstack mb-2">
                  <Form.Label className="fw-bold mb-0" style={{ fontSize: 13 }}>
                    Additional Information
                  </Form.Label>
                  <FaSquarePlus
                    className="ms-2 CP"
                    title="Add Additional Information"
                    onClick={() => setOpenList(!openList)}
                  />
                </div>
                <Collapse in={openList}>
                  <div className={`mb-3 ${!isDark && "bg-light"} border p-3 rounded`}>
                    <div className="d-flex gap-2 flex-wrap">
                      {fieldTypes?.map(item => (
                        <button
                          key={item?.type}
                          action
                          style={{ width: 81 }}
                          title={item?.label}
                          className={`category-card p-2 ${isDark ? "dark" : "bg-white"}`}
                          onClick={() => addField(item)}
                        >
                          <span style={{ fontSize: 16 }}>{item.icon}</span>
                          <span style={{ fontSize: 11 }}>{item.label}</span>
                        </button>
                      ))}
                    </div>
                  </div>
                </Collapse>
              </Form.Group>
              {itemInfo?.map(field => (
                <Form.Group key={field.id} className="mb-3">
                  {field?.define === "post" &&
                    <>
                      {field.type === "textarea" ? (
                        <Form.Group className="position-relative my-4">
                          <Form.Control
                            type="text"
                            className="interactive-input fw-bold"
                            placeholder="Enter Label"
                            value={field.label}
                            onChange={(e) => {
                              handleChange(field.id, "label", e.target.value);
                              handleChange(field.id, "name", toFieldName(e.target.value))
                            }}
                            style={{
                              fontSize: 12,
                              width: "40%",
                              position: "absolute",
                              top: -15,
                              left: 0,
                              padding: "6px 12px",
                              zIndex: 2,
                            }}
                          />
                          <Button
                            size="sm"
                            title="Remove this Info"
                            variant="danger"
                            className="position-absolute rounded-circle p-0 bg-danger-subtle border-danger text-danger"
                            style={{
                              top: -7,
                              right: -7,
                              zIndex: 999,
                              lineHeight: 1,
                              width: 18,
                              height: 18,
                              fontSize: 10
                            }}
                            onClick={() => removeField(field.id)}
                          >
                            <FaXmark />
                          </Button>
                          <Form.Control
                            as="textarea"
                            rows={3}
                            className="interactive-input"
                            placeholder={field?.placeholder}
                            style={{ fontSize: 12, padding: "26px 15px 10px" }}
                          />
                        </Form.Group>
                      ) : field.type === "password" ?
                        <InputGroup className="position-relative mb-3">
                          <Form.Control
                            type="text"
                            className="interactive-input fw-bold"
                            style={{ fontSize: 12, padding: "6px 15px", width: "30%" }}
                            placeholder="Enter Label"
                            value={field.label}
                            onChange={(e) => {
                              handleChange(field.id, "label", e.target.value);
                              handleChange(field.id, "name", toFieldName(e.target.value))
                            }}
                          />
                          <Form.Control
                            type={showPasswordMap[field.id] ? "text" : "password"}
                            className="interactive-input"
                            style={{ fontSize: 12, padding: "6px 15px", width: "60%" }}
                            placeholder={field?.placeholder}
                            value={field.value}
                            onChange={(e) => handleChange(field.id, "value", e.target.value)}
                          />
                          <Button
                            size="sm"
                            title="Remove this Info"
                            variant="danger"
                            className="position-absolute rounded-circle p-0 bg-danger-subtle border-danger text-danger"
                            style={{
                              top: -7,
                              right: -7,
                              zIndex: 999,
                              lineHeight: 1,
                              width: 18,
                              height: 18,
                              fontSize: 10
                            }}
                            onClick={() => removeField(field.id)}
                          >
                            <FaXmark />
                          </Button>
                          <InputGroup.Text
                            style={{ cursor: "pointer" }}
                            onClick={() => toggleShowPassword(field.id)}
                          >
                            {showPasswordMap[field.id] ? <FaEyeSlash /> : <FaEye />}
                          </InputGroup.Text>
                        </InputGroup>
                        : (
                          <InputGroup className="position-relative mb-3">
                            <Form.Control
                              type="text"
                              className="interactive-input fw-bold"
                              style={{ fontSize: 12, padding: "6px 15px", width: "30%" }}
                              placeholder="Enter Label"
                              value={field.label}
                              onChange={(e) => {
                                handleChange(field.id, "label", e.target.value);
                                handleChange(field.id, "name", toFieldName(e.target.value))
                              }}
                            />
                            <Form.Control
                              type={field.type}
                              className="interactive-input"
                              style={{ fontSize: 12, padding: "6px 15px", width: "60%" }}
                              placeholder={field?.placeholder}
                              value={field.value}
                              onChange={(e) => handleChange(field.id, "value", e.target.value)}
                            />
                            <Button
                              size="sm"
                              title="Remove this Info"
                              variant="danger"
                              className="position-absolute rounded-circle p-0 bg-danger-subtle border-danger text-danger"
                              style={{
                                top: -7,
                                right: -7,
                                zIndex: 999,
                                lineHeight: 1,
                                width: 18,
                                height: 18,
                                fontSize: 10
                              }}
                              onClick={() => removeField(field.id)}
                            >
                              <FaXmark />
                            </Button>
                          </InputGroup>
                        )}
                    </>
                  }
                </Form.Group>
              ))}
            </>
          }
        </div>
      </div>
    </>
  );
};

export default UpdateItem;
